import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.css';

function ScoreRenderer(props) {
  const { value } = props;
  let cls = '';
  if (value > 0) {
    cls = 'label-success';
  } else if (value < 0) {
    cls = 'label-danger';
  }
  return (
    <div className="text-left">
      <span className={`label ${cls} ${styles.label}`}>
        {value}
      </span>
    </div>
  );
}
ScoreRenderer.propTypes = {
  value: PropTypes.number,
};
ScoreRenderer.defaultProps = {
  value: null,
};

export default ScoreRenderer;
